import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import {
  Text,
  Stack,
  TextLink,
  IconNewWindow,
  Inline,
} from 'braid-design-system';
import urls from 'src/constants/urls';
import { observer } from 'mobx-react';
import { CertsyLegalDisclaimer } from 'src/components/common/Certsy/CertsyLegalDisclaimer';

export const CertsyVerifiedBadgeTooltipContent = observer(() => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="medium">
      <Text>
        {t(
          "This candidate has verified some of their information with Certsy - SEEK's trusted verification partner.",
        )}
      </Text>
      <CertsyLegalDisclaimer />

      <Inline space="small" align="right">
        <Text weight="strong">
          <TextLink href={urls.CERTSY_OFFICIAL_LINK} target="_blank">
            {t('Learn more about Certsy')} <IconNewWindow />
          </TextLink>
        </Text>
      </Inline>
    </Stack>
  );
});
